jQuery(document).ready(function ($) {
    function transformText(text) {
        // Remove special characters using regex
        let withoutSpecialChars = text.replace(/[^\w\s]/gi, '');
        // Convert to lowercase
        let lowercaseText = withoutSpecialChars.toLowerCase();
        // Replace spaces with hyphens
        let withHyphens = lowercaseText.replace(/\s+/g, '-');
        return withHyphens;
    }


    let single = $('.single');
    let page = $('.page-template');

    if (single.length > 0 || page.length > 0) {
        let header = $('.header');
        let navHeight = header.outerHeight();
        let pageContent;
        let filteredHeadings;

        if (single.length == 0) {
            pageContent = $('.flexible-section');
            filteredHeadings = pageContent.find('h2:not(.block--cta h2)');
        }

        if (page.length == 0) {
            pageContent = $('.page-content');
            filteredHeadings = pageContent.find('h2:not(.block--cta h2), h3:not(.block--cta h3, .blocks__item h3)');
        }

        let pageNavUl = $('.page-nav ul');
        let isFirstItem = true;

        function updateNavHeight() {
            navHeight = header.outerHeight();
        }

        // Initial calculation
        updateNavHeight();

        // Recalculate on window resize
        $(window).resize(updateNavHeight);

        filteredHeadings.each(function(index) {
            let headingText = $(this).text();
            let transformedText = transformText(headingText);
            let headingId = transformedText;

            // Assign the ID to the current heading
            $(this).attr('id', headingId);

            // Create a new list item with an anchor link
            let listItem = $('<li>');
            let anchorLink = $('<a>', {
                'href': '#' + headingId,
                'text': headingText,
                'class': 'page-nav__item'
            });

            if (isFirstItem) {
                listItem.addClass('active');
                isFirstItem = false;
            }

            // Append the anchor link to the list item
            listItem.append(anchorLink);

            // Append the list item to the pageNav
            pageNavUl.append(listItem);
        });



        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - navHeight - 100
            }, 10);
        });

        let pageNav = $('.page-nav');
        if (pageNav.length > 0) {
            $(window).scroll(function () {
                let st = $(window).scrollTop();
                if (st > 300) {
                    pageNav.addClass('page-nav--fixed');
                    header.addClass('header--fixed');
                    pageNav.css({
                        'transform': 'translate(0, ' + navHeight + 'px)',
                        'opacity': '1',
                        'max-height': '100%'
                    });
                } else {
                    pageNav.removeClass('page-nav--fixed');
                    header.removeClass('header--fixed');
                    pageNav.css({
                        'transform': 'translate(0, 0)',
                        'opacity': '0',
                        'max-height': '0'
                    });
                }
            });

            function centerFunction() {
                jQuery(".page-nav ul").scrollCenter(".active", 300);
            }
            setInterval(centerFunction, 500);

            if (filteredHeadings.length > 0) {

                $(window).scroll(function () {
                    filteredHeadings.each(function () {

                        let id = $(this).attr('id');
                        let distance = $('#' + id + '').offset().top - 260;
                        let $window = $(window);

                        if ($window.scrollTop() >= distance) {
                            $('.page-nav ul li a').removeClass('active-link');
                            $('.page-nav ul li a[href^="#' + id + '"]').addClass('active-link');

                            $('.page-nav ul li').removeClass('active');
                            $('.page-nav ul li a[href^="#' + id + '"]').parent().addClass('active');
                        } else {
                            $('.page-nav ul li a[href^="#' + id + '"]').removeClass('active-link');
                        }
                    });
                });
            }

            jQuery.fn.scrollCenter = function(elem, speed) {
                let active = jQuery(this).find(elem); // find the active element

                if (!active || active.length === 0) {
                    return this;
                }

                let activeWidth = active.width() / 2; // get active width center
                let position = active.position();

                if (!position) {
                    return this;
                }

                let pos = position.left + activeWidth; // get left position of active li + center position
                let elpos = jQuery(this).scrollLeft(); // get current scroll position
                let elW = jQuery(this).width(); // get div width
                pos = pos + elpos - elW / 2; // for center position if you want adjust then change this

                jQuery(this).animate({
                    scrollLeft: pos
                }, speed == undefined ? 1000 : speed);
                return this;
            };
        }
    }
});
